import {
  LOAD_CACHE_EXCLUDE,
  LOAD_CACHE_EXCLUDE_FAIL,
  LOAD_CACHE_EXCLUDE_SUCCESS,
  LoadCacheExclude,
  LoadCacheExcludeFail,
  LoadCacheExcludeSuccess
} from '../actions/hosting-cache-exclude.action';
import {CacheExcludeAction} from "../actions";

export interface IHostingEntityState {
  entities: {[websiteId: number]: any};
  loading: boolean;
  loaded: boolean;
}

export interface IHostingCacheExcludeState {
  entities: {[websiteId: number]: IHostingEntityState};
}

export const initialState: IHostingCacheExcludeState = {
  entities: {}
};

export function reducer(state: IHostingCacheExcludeState = initialState, action: CacheExcludeAction): IHostingCacheExcludeState {
  let payload: any;

  switch (action.type) {

    case LOAD_CACHE_EXCLUDE:
      payload = (<LoadCacheExclude>action).payload;

      return {
        ...state,
        entities: {
          ...state.entities,
          [payload]: {
            ...state[payload],
            loading: true,
            loaded: false
          }
        }
      };

    case LOAD_CACHE_EXCLUDE_SUCCESS:
      payload = (<LoadCacheExcludeSuccess>action).payload;
      return {
        ...state,
        entities: {
          [payload.websiteId]: {
            ...state.entities[payload.websiteId],
            entities: payload.entities,
            loading: false,
            loaded: true
          }
        }
      };

    case LOAD_CACHE_EXCLUDE_FAIL:
      payload = (<LoadCacheExcludeFail>action).payload;

      return {
        ...state,
        entities: {
          ...state.entities,
          [payload.websiteId]: {
            ...state.entities[payload.websiteId],
            loading: false,
            loaded: true
          }
        }
      };

  }

  return state;
}
